import { useEffect, useState } from "react";
import { Button } from "@link/ui";
import { currentDmSoundEnabled, previewDmSound, setDmSoundEnabled } from "../lib/dm-notifications";

export function NotificationSettings() {
  const [enabled, setEnabled] = useState(currentDmSoundEnabled);
  const [notice, setNotice] = useState("");
  useEffect(() => {
    const sync = () => setEnabled(currentDmSoundEnabled());
    window.addEventListener("storage", sync);
    window.addEventListener("link:notification-settings", sync);
    return () => { window.removeEventListener("storage", sync); window.removeEventListener("link:notification-settings", sync); };
  }, []);
  return <section className="max-w-2xl space-y-6">
    <header><h2 className="text-2xl font-semibold text-cloud-800">Notifications</h2>
      <p className="mt-1 text-sm text-cloud-500">Choose how Link gets your attention on this device.</p></header>
    <div className="space-y-4 rounded-2xl border border-cloud-200 bg-cloud-50/50 p-5">
      <label className="flex cursor-pointer items-center justify-between gap-5">
        <span><span className="block font-semibold text-cloud-800">Message sounds</span>
          <span className="mt-1 block text-sm text-cloud-500">A soft chime for new direct and group messages.</span></span>
        <input type="checkbox" className="h-5 w-5 accent-strawberry-600" checked={enabled}
          onChange={event => { setDmSoundEnabled(event.target.checked); setEnabled(event.target.checked); }} />
      </label>
      <p className="text-sm text-cloud-500">Muted conversations, Do Not Disturb, and deafen stay quiet. No chime while you’re viewing that conversation.</p>
      <Button variant="outline" onClick={() => void previewDmSound().then(ok => setNotice(ok ? "Preview played." : "Your browser blocked audio. Check this site's sound settings and try again."))}>Preview sound</Button>
      <p className="text-xs text-cloud-500">Keep Link open to receive live updates. Browsers may pause background tabs; sound starts after you interact with Link. This does not enable notifications when Link is closed.</p>
      {notice && <p role="status" className="text-sm text-cloud-600">{notice}</p>}
    </div>
  </section>;
}
